/**
 * Internal dependencies
 */
import './store';
